module.exports = __webpack_public_path__ + "static/media/rishi.df823231.jpeg";